import { Link } from 'react-router-dom';
import { MessageSquare, Twitter, Linkedin, Instagram } from 'lucide-react';
import { SectionLink } from './SectionLink';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const links = {
    product: [
      { name: 'Features', id: 'features' },
      { name: 'How It Works', id: 'how-it-works' },
      { name: 'Pricing', id: 'pricing' },
      { name: 'About', id: 'about' },
    ],
    legal: [
      { name: 'Privacy Policy', to: '/privacy' },
      { name: 'Terms of Service', to: '/terms' },
      { name: 'Refund Policy', to: '/refund' },
    ],
    support: [
      { name: 'Contact Us', to: '/contact' },
      { name: 'FAQs', to: '/faq' },
      { name: 'Help Center', to: '/help' },
    ],
  };

  return (
    <footer className="bg-slate-50 dark:bg-slate-900 border-t border-slate-200 dark:border-slate-800" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img
                src={`${process.env.PUBLIC_URL || ''}/assistlylogo.png`}
                alt="AssistlyAI"
                className="h-8 w-auto max-h-8 object-contain"
              />
              <span className="text-xl font-bold text-slate-900 dark:text-white">AssistlyAI</span>
            </Link>
            <p className="text-slate-600 dark:text-slate-400 mb-6 max-w-sm">
              Your AI personal assistant that lives inside WhatsApp. Manage meetings, reminders, and your entire workday with simple messages.
            </p>
            {/* Social Links */}
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-full bg-slate-200 dark:bg-slate-800 flex items-center justify-center text-slate-600 dark:text-slate-400 hover:bg-[#25D366] hover:text-white transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-slate-200 dark:bg-slate-800 flex items-center justify-center text-slate-600 dark:text-slate-400 hover:bg-[#25D366] hover:text-white transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-slate-200 dark:bg-slate-800 flex items-center justify-center text-slate-600 dark:text-slate-400 hover:bg-[#25D366] hover:text-white transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://wa.me/919981361957" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-slate-200 dark:bg-slate-800 flex items-center justify-center text-slate-600 dark:text-slate-400 hover:bg-[#25D366] hover:text-white transition-colors">
                <MessageSquare className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Product Links */}
          <div>
            <h4 className="font-semibold text-slate-900 dark:text-white mb-4">Product</h4>
            <ul className="space-y-3">
              {links.product.map((link) => (
                <li key={link.name}>
                  <SectionLink
                    id={link.id}
                    className="text-slate-600 dark:text-slate-400 hover:text-[#25D366] transition-colors"
                  >
                    {link.name}
                  </SectionLink>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="font-semibold text-slate-900 dark:text-white mb-4">Legal</h4>
            <ul className="space-y-3">
              {links.legal.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.to}
                    className="text-slate-600 dark:text-slate-400 hover:text-[#25D366] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support Links */}
          <div>
            <h4 className="font-semibold text-slate-900 dark:text-white mb-4">Support</h4>
            <ul className="space-y-3">
              {links.support.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.to}
                    className="text-slate-600 dark:text-slate-400 hover:text-[#25D366] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

<div>
  <a
    href="https://www.producthunt.com/products/assistlyai?embed=true&utm_source=badge-featured&utm_medium=badge&utm_campaign=badge-assistlyai"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      alt="AssistlyAI - Turn WhatsApp Into Your Smart Productivity Assistant | Product Hunt"
      width="250"
      height="54"
      src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=1177873&theme=light&t=1782154094897"
    />
  </a>
</div>


          
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-200 dark:border-slate-800 mt-12 pt-8 flex flex-col gap-4 text-center md:text-left">
          <div className="flex flex-col md:flex-row md:flex-wrap md:items-center md:justify-between gap-3 text-sm text-slate-500 dark:text-slate-400">
            <p>© {currentYear} AssistlyAI. All rights reserved.</p>
            <p>
              Designed &amp; developed by{' '}
              <a
                href="https://www.devyugsolutions.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#25D366] hover:text-[#1DA851] font-medium transition-colors"
              >
                Devyug Solutions
              </a>
              .
            </p>
            <p>Made with ❤️ in India</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
